import { render, staticRenderFns } from "./SectionApp.vue?vue&type=template&id=9c4e5f3a&scoped=true"
import script from "./SectionApp.vue?vue&type=script&lang=js"
export * from "./SectionApp.vue?vue&type=script&lang=js"
import style0 from "./SectionApp.vue?vue&type=style&index=0&id=9c4e5f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4e5f3a",
  null
  
)

export default component.exports